import { Injectable, inject } from '@angular/core';
import { NgbDatepickerI18n, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

const I18N_VALUES: { [id: string]: { weekdays: string[]; months: string[] } } = {
  th: {
    weekdays: ['จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส', 'อา'],
    months: ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'],
  },
  // other languages you would support
};

/** Holds the active datepicker language. */
@Injectable()
export class I18n {
  language = 'th';
}

/** Provides the Thai months/weekdays translations and Buddhist-era year numerals. */
@Injectable()
export class CustomDatepickerI18n extends NgbDatepickerI18n {
  private readonly i18n = inject(I18n);

  override getWeekdayLabel(weekday: number): string {
    return I18N_VALUES[this.i18n.language].weekdays[weekday - 1];
  }

  getWeekdayShortName(weekday: number): string {
    return I18N_VALUES[this.i18n.language].weekdays[weekday - 1];
  }

  override getMonthShortName(month: number): string {
    return I18N_VALUES[this.i18n.language].months[month - 1];
  }

  override getMonthFullName(month: number): string {
    return this.getMonthShortName(month);
  }

  override getDayAriaLabel(date: NgbDateStruct): string {
    return `${date.day}-${date.month}-${date.year}`;
  }

  override getYearNumerals(year: number): string {
    return `${year + 543}`;
  }
}
